import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Upload as HljdUpload, message } from 'hljd'

@observer
export default class extends Component {
  /*  onCliped = () => ({ clipUrl }) => {
    this.props.uploadedSuccess({
      width: 0,
      height: 0,
      url: clipUrl
    })
  }*/
  handleImgChange = info => {
    if (!info || info?.length === 0 || info.url?.indexOf('imageMogr2') === -1) {
      this.props.removePhoto()
      return
    }
    this.props.uploadedSuccess({
      width: 0,
      height: 0,
      url: info.url
    })
  }

  handleBeforeUpload = async file => {
    const { width, height } = await HljdUpload.checkSizeSync(file)
    if (file.size > 1024 * 1024 * 15) {
      message.error('图片大小不能超过15M')
      return Promise.reject(file)
    } else if (width < 1080 || height < 608) {
      message.error('宽>=1080，高>=608')
      return Promise.reject(file)
    } else {
      return Promise.resolve(file)
    }
  }

  render() {
    const { coverInfo } = this.props
    return (
      <HljdUpload
        width={134}
        height={100}
        upText={''}
        clipable
        // disabled={true}
        listMode={false}
        accept=".jpg,.gif,.png,.jpeg,.bmp"
        aspect={16 / 9}
        max={1}
        value={
          coverInfo.cover_path
            ? { url: coverInfo.cover_path, type: 'image' }
            : null
        }
        onChange={this.handleImgChange}
        beforeUpload={this.handleBeforeUpload}
      />
    )
    /* if (coverInfo && coverInfo.cover_path) {
      return (
        <ImgCard
          isLoading={isUploading}
          src={coverInfo.cover_path}
          onDelete={removePhoto}
        />
      )
    }
    return (
      <Upload
        // disabled={true}
        clipabled
        link={coverInfo.cover_path}
        onCliped={this.onCliped()}
        aspect={16 / 9}
       /!* description={
          <div className={style.coverUploader}>
            <p>1080*608</p>
          </div>
        }*!/
        filters={{
          mime_types: [
            {
              title: 'images files',
              extensions: 'jpg,gif,png,jpeg,bmp'
            }
          ],
          max_file_size: '15mb',
          prevent_duplicates: true
        }}
        onBeforeUp={async (up, file) => {
          return new Promise((resolve, reject) => {
            Upload.checkSize(file, ({ width, height }) => {
              if (width < 1080 || height < 608) {
                message.warn(`宽>=1080，高>=608`)
                reject(false)
              } else {
                resolve(true)
              }
            })
          })
        }}
      />
    )*/
  }
}
